<template>
    <div class="messagepanewrap" v-if="folderId">
        <div class="messagelistwrap">
            <div class="bottompane">
                <div class="loading" v-show="loading && !msgid">
                    <div class="loadingtext">
                        {{$t('general:text.loading')}}
                        <font-awesome-icon icon="spinner-third" spin></font-awesome-icon>
                    </div>
                </div>
                <keep-alive>
                    <router-view name="bottompane" :messages="messages"
                            :selectedUIDs="selectedUIDs" :selectIndex="selectIndex"
                            :selectedMessageNumber="selectedMessageNumber"
                            :totalFolderSize="totalLength" :filteredLength="filteredLength"
                            :rights="rights" :pageLength="pageLength"
                            :showRefresh="needsRefresh" :outqueueShowSent="outqueueShowSent"
                            :start="parseInt(loadedStart, 10) - 1"
                            @updateMessages="updateMessages" @deleteMessages="deleteMessages"
                            @moveMessages="moveMessages" @compose="$emit('compose', $event)"
                            @messageUpdated="messageUpdated" @selectMessage="selectMessage"
                            @showMessage="showMessage" @selectAll="selectAll"
                            @search="doSearch" @page="doPager"
                            @menu="doMenu" @check="doCheck"/>
                </keep-alive>
            </div>
        </div>
        <vue-window-portal v-for="(w, key) in extWindows" :key="`${key}`" :open="true" :ref="`window-${key}`"
                preloadUrl="/blank.html" @closed="closeWindow(key)" :top="w.top" :left="w.left" :width="w.width"
                :height="w.height" :title="w.title">
            <message-source v-if="w.raw" :source="w.raw"></message-source>
            <message-view v-else :messages="messages"
                    :folderid="w.folderid" :msgid="w.uid"
                    :extWindow="true"
                    :selectedMessageNumber="selectedMessageNumber"
                    :totalFolderSize="totalLength"
                    @updateMessages="updateMessages" @deleteMessages="deleteMessages"
                    @moveMessages="moveMessages" @compose="$emit('compose', $event)">
            </message-view>
        </vue-window-portal>
    </div>
</template>

<script>
// import MessageLine from '@/components/messageLine';
// import MessageControlBar from '@/components/messageControlBar';
// import MessageView from '@/components/messageView';
import axios from 'axios';
import { EventBus } from '@/event-bus';
import * as Sentry from '@sentry/browser';
import VueWindowPortal from '@/components/VueWindowPortal';
import MessageView from '@/components/messageView';
import MessageSource from '@/components/messageSource';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
// import MessageListView from '@/components/messageListView';

export default {
  name: 'messageList',
  components: { MessageView, MessageSource, VueWindowPortal, FontAwesomeIcon },
  props: {
    // folder: Object,
    startpos: String,
    folderid: String,
    msgid: String,
    pageLength: {
      type: Number,
      default: 50
    }
  },
  data: function() {
    return {
      // start: 0,
      loadedFolderid: '',
      loadedStart: '',
      messages: [],
      totalLength: 0,
      selectedMessageNumber: 0,
      selectIndex: -1,
      selectedUIDs: { },
      needsRefresh: false,
      extWindows: {},
      extWindowCounter: 0,
      extWindowPos: 100,
      extWindowWidth: 600,
      extWindowHeight: 400,
      searchText: '',
      filteredLength: -1,
      loading: false,
      outqueueShowSent: false,
      rights: ''
    };
  },
  watch: {
    folderid() {
      console.log('msglist folder changed');
      this.selectedUIDs = {};
      this.selectIndex = -1;
      Sentry.addBreadcrumb({
        category: 'ui',
        message: 'Folder Selected:' + this.$store.getters.getFolderById(this.folderId),
        level: 'info'
      });
      this.$socket.sendObj({ folder: this.folderId });
    },
    startpos(val) {
      console.log('msglist start changed');
      // this.loadPage(val - 1);
    },
    '$route': function(val) {
      if ((val.params.folderid !== this.loadedFolderid) || (val.params.startpos !== this.loadedStart)) {
        console.log('$route changed', val);
        this.loadPage(val.params.startpos - 1);
      }
    }
  },
  beforeRouteUpdate(to, from, next) {
    console.log('msglist bru', to, from, this.$route);
    next();
  },
  created() {
    EventBus.$on('messageListRefresh', ({ folderId }) => {
      console.log('eb refresh', typeof folderId, folderId, typeof this.folderId, this.folderId);
      if (folderId === this.folderId) {
        console.log('eb refresh 2');
        this.loadPage(0);
      }
    });
    EventBus.$on('messageUpdate', ({ folderId, update }) => {
      if (update.action === 'delete') {
        this.messageUpdated({ folderId, uid: update.uid, newValues: { deleted: true } });
        this.needsRefresh = true;
      } else if (update.action === 'update') {
        this.messageUpdated({ folderId, uid: update.uid, newValues: update.message });
      } else if (update.action === 'insert') {
        this.needsRefresh = true;
      }
    });
    EventBus.$on('outboxMessage', msg => {
      if (this.folderId === -1) {
        if (msg.action === 'INSERT') {
          if (this.searchText === '') {
            this.messages.unshift(msg.msg);
            this.totalLength++;
            if (this.messages.length > this.pageLength) {
              this.messages.pop();
            }
          } else {
            this.loadPage(this.start);
          }
        } else if (msg.action === 'DELETE') {

        } else if (msg.action === 'UPDATE') {
          console.log('update outbox message', msg.msgid);
          let ind = this.messages.findIndex(m => m.uid === msg.msgid);
          if (ind !== -1) {
            if (this.outqueueShowSent) {
              this.$set(this.messages, ind, msg.msg);
            } else if (msg.msg.read) {
              this.$delete(this.messages, ind);
            }
          }
        }
      }
    });
    this.$socket.sendObj({ folder: this.folderId });
  },
  mounted() {
    console.log('mounted');
    this.loadPage(this.start);
  },
  beforeDestroy() {
    EventBus.off('messageListRefresh');
    EventBus.off('messageUpdate');
  },
  methods: {
    doSearch(searchText) {
      this.searchText = searchText;
      this.loadPage(this.start);
    },
    loadPage(newStart) {
      console.log('loadPage', this.folderId, newStart);
      this.loading = true;
      return new Promise((resolve, reject) => {
        if ((this.folderId)) {
          const loadFolderId = this.folderid;
          const loadStart = this.startpos;
          axios
            .get(`/rest/user/folders/${this.folderId}?start=${newStart}&length=${this.pageLength}&` +
              `search=${this.searchText}&sent=${this.outqueueShowSent ? 1 : 0}`)
            .then(d => {
              if ((d.data.start === this.start) && (d.data.folder.id === this.folderId)) {
                console.log('got messages', d.data);
                if (d.data.folder.id === -2) {
                  this.$store.commit('setFolderInfo', d.data.folder);
                }
                this.messages = d.data.messages;
                this.totalLength = d.data.size;
                this.filteredLength = d.data.filteredSize;
                // this.start = newStart;
                this.selectIndex = -1;
                this.needsRefresh = false;
                this.rights = d.data.folder.rights;
                this.loadedFolderid = loadFolderId;
                this.loadedStart = loadStart;
              }
            })
            .catch(e => {
              console.log(e);
              console.log('Get messages failed');
            })
            .finally(() => {
              console.log('end get messages');
              this.loading = false;
              resolve();
            });
        }
      });
    },
    changePage(newStart) {
      console.log('changePage', newStart);
      if ((newStart >= 0) && (newStart < this.visibleLength)) {
        console.log('change page', this.$route);
        this.$router.push(`/${this.$route.params.foldertype}/${this.folderid}/${newStart + 1}`);
      }
    },
    doPager(newStart) {
      if (this.$route.params['msgid']) {
        this.changeMessage(newStart);
      } else {
        this.changePage(newStart);
      }
    },
    closeWindow(key) {
      this.$delete(this.extWindows, key);
    },
    showSource() {
      const evt = {};
      this.showExtWindow(parseInt(this.msgid, 10), evt, true);
    },
    showExtWindow(uid, evt, showRaw) {
      const key = `${this.folderid}-${uid}-${this.extWindowCounter++}`;
      console.log('create new external window', key);
      let title = this.$t('messageView.noSubject');
      for (let i = 0; i < this.messages.length; i++) {
        if (this.messages[i].uid === uid) {
          title = this.messages[i].subject;
          break;
        }
      }
      const w = {
        folderid: this.folderid,
        uid: uid.toString(),
        left: this.extWindowPos,
        top: this.extWindowPos,
        width: this.extWindowWidth,
        height: this.extWindowHeight,
        title };
      if (evt.shiftKey) {
        this.extWindowPos += 30;
        if (this.extWindowPos + this.extWindowWidth >= screen.width) {
          this.extWindowPos = 30;
        } else if (this.extWindowPos + this.extWindowHeight >= screen.height - 60) {
          this.extWindowPos = 30;
        }
      }
      if (showRaw) {
        axios
          .get(`rest/user/folders/${this.folderId}/${this.msgid}/raw`)
          .then(d => {
            w.raw = d.data.raw;
            this.$set(this.extWindows, key, w);
          });
      } else {
        this.$set(this.extWindows, key, w);
      }
    },
    showMessage({ uid, evt }) {
      if (evt && (evt.ctrlKey || evt.shiftKey)) {
        this.showExtWindow(uid, evt, false);
      } else {
        Sentry.addBreadcrumb({
          category: 'ui',
          message: 'Show message:' + uid,
          level: 'info'
        });
        for (let i = 0; i < this.messages.length; i++) {
          if (this.messages[i].uid === uid) {
            this.selectedMessageNumber = i + this.start;
            break;
          }
        }
        this.$router.push(`/${this.$route.params.foldertype}/${this.folderid}/` +
          `${this.start + 1}/${uid}`);
      }
    },
    hideMessage() {
      this.$router.push(`/${this.$route.params.foldertype}/${this.folderid}/` +
        `${this.start + 1}`);
      // this.selectedMessage = null;
      this.focusMessageList();
    },
    focusMessageList() {
      /*
        console.log('focusMessageList', this.$refs);
        this.$nextTick(() => {
          console.log('focus nexttick', this, this.$refs);
          this.$refs['messagelist'].focus();
        });
        */
    },
    changeMessage(newMessageNumber) {
      if ((newMessageNumber >= 0) && (newMessageNumber < this.totalLength)) {
        console.log(`Change Message from ${this.selectedMessageNumber} to ${newMessageNumber}`);
        const index = newMessageNumber - this.start;
        if (index < 0) {
          let newStart = this.start - this.pageLength;
          if (newStart >= 0) {
            this.selectedMessageNumber = newMessageNumber;
            this.loadPage(newStart);
          }
        } else if (index >= this.pageLength) {
          let newStart = this.start + this.pageLength;
          if (newStart < this.totalLength) {
            this.selectedMessageNumber = newMessageNumber;
            this.loadPage(newStart);
          }
        } else {
          this.showMessage({ uid: this.messages[index].uid });
        }
      }
    },
    messageUpdated({ folderId, uid, newValues }) {
      console.log('msg updated', folderId, uid, newValues);
      if (folderId !== this.folderId) {
        console.log('different folder', this.folderId, folderId);
        return;
      }

      const ind = this.messages.findIndex(m => m.uid === uid);
      if (ind !== -1) {
        this.$set(this.messages, ind, Object.assign(this.messages[ind], newValues));
      }
    },
    selectMessage({ folder, uid, shift }) {
      this.focusMessageList();
      if (folder !== this.folderId) {
        console.log('folder mismatch');
        return;
      }
      console.log('selectMessage', uid, this.selectedUIDs);
      if (this.selectedUIDs[uid]) {
        this.$delete(this.selectedUIDs, uid);
      } else {
        this.$set(this.selectedUIDs, uid, true);
      }
      const ind = this.messages.findIndex(m => m.uid === uid);
      if ((shift) && (this.selectIndex !== -1) && (ind !== -1)) {
        const sel = !!this.selectedUIDs[uid];
        const from = Math.min(ind, this.selectIndex);
        const to = Math.max(ind, this.selectIndex);
        if (sel) {
          for (let i = from; i <= to; i++) {
            this.$set(this.selectedUIDs, this.messages[i].uid, true);
          }
        } else {
          for (let i = from; i <= to; i++) {
            this.$delete(this.selectedUIDs, this.messages[i].uid);
          }
        }
      }
      this.selectIndex = ind;
    },
    selectAll(val) {
      if (val) {
        this.messages.forEach(m => {
          this.$set(this.selectedUIDs, m.uid, true);
        });
      } else {
        this.messages.forEach(m => {
          this.$delete(this.selectedUIDs, m.uid);
        });
      }
    },
    updateMessages({ uids, newVal }) {
      return new Promise((resolve, reject) => {
        console.log('updatemessages', uids, newVal);
        const obj = {
          uids,
          value: newVal
        };
        const folderId = this.folderId;
        axios
          .patch(`/rest/user/folders/${folderId}`, obj)
          .then(d => {
            if (this.folderId === folderId) {
              d.data.messages.forEach(uid => {
                const ind = this.messages.findIndex(m => m.uid === uid);
                if (ind !== -1) {
                  this.$set(this.messages, ind, Object.assign(this.messages[ind], newVal));
                }
              });
            }
            resolve();
          });
      });
    },
    deleteMessages(uids) {
      this.doDeleteMessages(uids)
        .then(() => {
          if (uids.indexOf(parseInt(this.msgid, 10)) !== -1) {
            this.changeMessage(this.selectedMessageNumber);
          }
        });
    },
    doDeleteMessages(uids) {
      return new Promise((resolve, reject) => {
        const TrashFolderName = this.$store.state.specialFolders['\\Trash'];
        let TrashFolder = null;
        if (TrashFolderName && (this.rights.indexOf('q') === -1)) {
          TrashFolder = this.$store.getters.getFolderByName(TrashFolderName);
          console.log('Trash Folder', TrashFolder);
          if ((TrashFolder) && (TrashFolder.id !== this.folderId)) {
            this.doMoveMessages({ uids, targetFolder: TrashFolder, copy: false, markRead: true })
              .then(resolve);
            return;
          }
        }

        const folderId = this.folderId;
        const obj = {
          uids
        };
        if (this.rights.indexOf('e') !== -1) {
          obj.value = { expunged: true };
        } else {
          obj.value = { deleted: true, read: true };
        }
        axios
          .patch(`/rest/user/folders/${folderId}`, obj)
          .then(d => {
            console.log('deleted', d);
            this.processDeletedMessages(folderId, d.data.messages)
              .then(resolve);
          });
      });
    },
    processDeletedMessages(origFolderId, messages) {
      return new Promise((resolve, reject) => {
        let deleteCount = 0;
        if (this.folderId === origFolderId) {
          messages.forEach(uid => {
            const ind = this.messages.findIndex(m => m.uid === uid);
            if (ind !== -1) {
              this.$delete(this.messages, ind);
              deleteCount++;
            }
            this.$delete(this.selectedUIDs, uid);
          });
          this.totalLength -= deleteCount;
          let newStart = this.start;
          while (this.totalLength <= newStart) {
            newStart -= this.pageLength;
          }

          if (newStart < 0) {
            newStart = 0;
          }

          this.loadPage(newStart)
            .then(resolve);
        }
      });
    },
    moveMessages({ uids, targetFolder, copy }) {
      this.doMoveMessages({ uids, targetFolder, copy })
        .then(() => {
          if (!copy && (uids.indexOf(parseInt(this.msgid, 10)) !== -1)) {
            this.changeMessage(this.selectedMessageNumber);
          }
        });
    },
    doMoveMessages({ uids, targetFolder, copy, markRead }) {
      return new Promise((resolve, reject) => {
        const obj = {
          uids,
          target: targetFolder.id,
          markRead: !!markRead
        };

        const copyType = copy ? 'copy' : 'move';
        const sourceFolderId = this.folderId;

        this.$RPC(`folders/${sourceFolderId}`, copyType, obj)
          .then(d => {
            console.log(`${copyType} done`, d);
            if (!copy) {
              this.processDeletedMessages(sourceFolderId, d.messages)
                .then(resolve);
            } else {
              resolve();
            }
          })
          .catch(e => {
            this.$dialog.alert(this.$t('general:alerts.rpcError', { error: e.message }));
          });
      });
    },
    doMenu(menu) {
      console.log('doMenu', menu);
      this[menu]();
    },
    doCheck({ name, checked }) {
      // this[name] = checked;
      if (name === 'outqueueShowSent') {
        this.outqueueShowSent = checked;
        this.loadPage(0);
      }
    },
    markAllRead() {
      const folderId = this.folderId;
      this.loading = true;
      this.$RPC(`folders/${folderId}`, 'markAllRead')
        .then(d => {
          if (folderId === this.folderId) {
            if (folderId === -2) {
              this.messages.forEach(m => {
                this.$set(this.messages, m.uid, Object.assign(m, { read: true }));
              });
              this.$store.commit('setFolderInfo', { id: -2, unread: 0 });
            }
          }
        })
        .catch(e => {
          this.$dialog.alert(this.$t('general:alerts.rpcError', { error: e.message }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    reloadMessages() {
      if (this.start === 0) {
        this.loadPage(0);
      } else {
        this.$router.push(`/${this.$route.params.foldertype}/${this.folderid}/1`);
      }
    },
    deleteAll() {
      const folderId = this.folderId;
      this.loading = true;
      this.$RPC(`folders/${folderId}`, 'deleteAll')
        .then(d => {
          if (folderId === this.folderId) {
            if (folderId === -2) {
              this.messages = [];
              this.$store.commit('setFolderInfo', { id: -2, unread: 0, msgs: 0 });
              this.reloadMessages();
            }
          }
        })
        .catch(e => {
          this.$dialog.alert(this.$t('general:alerts.rpcError', { error: e.message }));
        })
        .finally(() => {
          this.loading = false;
        });
    },
    undeleteAll() {
      const folderId = this.folderId;
      this.loading = true;
      this.$RPC(`folders/${folderId}`, 'undeleteAll')
        .then(d => {
          if (folderId === this.folderId) {
            if (folderId === -2) {
              this.reloadMessages();
            }
          }
        })
        .catch(e => {
          this.$dialog.alert(this.$t('general:alerts.rpcError', { error: e.message }));
        })
        .finally(() => {
          this.loading = false;
        });
    }
  },
  computed: {
    start() {
      return parseInt(this.startpos || 0, 10) - 1;
    },
    folderId() {
      return parseInt(this.folderid, 10);
    },
    visibleLength() {
      return this.filteredLength === -1 ? this.totalLength : this.filteredLength;
    }
  }
};
</script>

<style scoped lang="scss">
    @import '../assets/bootstrap-style.scss';

    .messagepanewrap {
        height: 100%;
        position: relative;

        .messagelistwrap {
            position: absolute;
            top: 0;
            bottom: 0;
            left: 0;
            right: 0;
        }
    }

    .bottompane {
        grid-area: messages;
        position: relative;
        height: 100%;

        .loading {
            background-color: rgba(0, 0, 0, 30%);
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            z-index: 100;
            .loadingtext {
                display: inline-block;
                background-color: $light;
                padding: 50px;
                opacity: 1;
                position: absolute;
                border-radius: 10px;
                top: 50%;
                left: 50%;
                transform: translate(-50%, -50%);
            }
        }
    }

</style>
